import { combineReducers } from 'redux'
import FutureAppointmentsByServiceReducer from './appointments.future.byservice.reducer'
import FutureAppointmentsMainReducer from './appointments.future.main.reducer'

const FutureAppointmentsReducer = combineReducers({
  byservice: FutureAppointmentsByServiceReducer,
  main: FutureAppointmentsMainReducer,
})

export default FutureAppointmentsReducer